// extracted by mini-css-extract-plugin
export default {"container":"FuwfFooter_container__PCGwB","row":"FuwfFooter_row__QLzcB","number":"FuwfFooter_number__F3N0U","delete":"FuwfFooter_delete__riNnu","button":"FuwfFooter_button__JulFs"};